
import { useContext } from 'react';
import { useVisningstypContext } from '../../../_Common/Components/BusinessCollectionComponents/VisningsTypContext/VisningsTypContext';
import { useIsSmallBreakpoint } from '../../../../../Components/BreakpointContext/BreakpointContextUtils';
import { BusinessDataFormContext } from '../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import EDTypography from '../../../../../BaseComponents/Typography/EDTypography';
import { ValueType } from '../../../../../Utils/Formatters/FormatterTypes';
import { useTheme } from '@mui/material';

interface IDataTableStatusDisplayProps {
  value: ValueType;
  displayValue: string;
  backgroundColor?: string;
  fontColor?: string;
  borderColor?: string;
  variant?: 'filled' | 'outlined';
  minWidth?: number | string;
  caption?: string;
}

export const DataTableStatusDisplay: React.FC<
  IDataTableStatusDisplayProps
> = props => {
  const theme = useTheme();
  const formContext = useContext(BusinessDataFormContext);
  const visningsTypContext = useVisningstypContext();
  const isSmallScreen = useIsSmallBreakpoint();

  const shouldShowChip = !(
    formContext ||
    isSmallScreen ||
    visningsTypContext.visningsTyp === 'kort' ||
    visningsTypContext.visningsTyp === 'lista'
  );

  const variant = props.variant || 'filled';

  const chipStyles = shouldShowChip
    ? {
        minWidth: theme.spacing(18),
        px: 1.25,
        borderRadius: 2,
        height: '34px',
        boxSizing: 'border-box',
        margin: '4px 0',
        backgroundColor:
          variant === 'filled'
            ? props.backgroundColor || 'transparent'
            : 'transparent',
        ...(props.borderColor || variant === 'outlined'
          ? {
              border: `2px solid ${
                props.borderColor ||
                props.backgroundColor ||
                theme.palette.divider
              }`,
            }
          : {}),
        color: props.fontColor || 'text.primary',
        lineHeight: '34px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        textAlign: 'center',
      }
    : {};

  return (
    <EDTypography variant="inherit" sx={chipStyles}>
      {props.caption ?? props.displayValue}
    </EDTypography>
  );
};
